import { APICore } from "./apiCore";

const api = new APICore();

interface VendorAnalyticsFilters {
    stallId?: number;
    festivalEvent?: number;
    fromDate?: string;
    toDate?: string;
}

// Get Vendor Dashboard
function getVendorDashboard(vendorId: number) {
    const baseUrl = `/vendors/${vendorId}/dashboard`;
    return api.get(baseUrl, "");
}

// Get Vendor Analytics
function getVendorAnalytics(
    vendorId: number,
    params?: VendorAnalyticsFilters
) {
    const baseUrl = `/vendors/${vendorId}/analytics`;
    return api.get(baseUrl, params || {});
}

function getVendors(params: {
    page: number;
    limit: number;
    sortType: string;
}) {
    return api.get("/vendors", params);
}

function getStallProducts(
    stallId: number,
    data: {
        customerId?: number;
        cartItems?: {
            productTierId: number;
            quantity: number;
        }[];
    } = {}
) {
    const baseUrl = `/vendors/stalls/${stallId}/products`;
    return api.create(baseUrl, data);
}

function getVendorStalls(params?: { vendorId?: number }) {
    return api.get('/vendors/stalls', params || {});
}

export {
    getVendors,
    getVendorDashboard,
    getVendorAnalytics,
    getStallProducts,
    getVendorStalls
};